import React from 'react'
import { URL_SRV_ARIZTIA } from '../../router/Url';

export const GetTheProducts_temp = ({FechaInicio, FechaFinal, empresa, MaqSelect}) => {
    // console.log({FechaInicio, FechaFinal, empresa, MaqSelect});
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_SRV_ARIZTIA+'products_temp',{
          method: 'POST',
          headers: {
            'authorization': "paico2021",
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "FECHA_INICIO": FechaInicio,
            "FECHA_FIN": FechaFinal,
            "EMPRESA": empresa,
            "MAQUINA": MaqSelect
          })
        })
        let responsito = await query.json();
        // console.log("ITEMS",responsito.body)
        if(responsito.success){
           resolve(responsito.body)
        }else{
            // Alert.alert('Medidores',responsito.msg)
            resolve([])
            return
          // resolve(responsito.data.body)
        }
    })
}
